<template>
    <div class="newsBox">
        <!--        仲裁协议签订信息-->
        <div class="signBox">
            <div class="signTitle">
                <p>
                    仲裁协议签订信息：
                </p>
            </div>
            <div class="signContent">
<!--                <p>仲裁协议签订方式：</p>-->
                <el-tabs>
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                            <el-form-item label="是否出调解书" prop="need_tjshu">
                                <el-radio v-model="ruleForm.need_tjshu" label="1">是</el-radio>
                                <el-radio v-model="ruleForm.need_tjshu" label="2">否</el-radio>
                            </el-form-item>
                            <el-form-item label="合同名称" prop="clause">
                                <el-input v-model="ruleForm.clause" placeholder="请输入合同名称"></el-input>
                            </el-form-item>
                            <el-form-item label="合同编号">
                                <el-input v-model="ruleForm.contract_sn" placeholder="请输入合同编号"></el-input>
                            </el-form-item>
                            <el-form-item label="签订日期" prop="time">
                                <el-date-picker
                                        v-model="ruleForm.time"
                                        value-format='yyyy-MM-dd'
                                        type="date"
                                        @change="getTime"
                                        placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
<!--                            <el-form-item label="案由" prop="cause">-->
<!--                                <el-input v-model="ruleForm.cause" placeholder="请输入案由"></el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item label="涉案金额" prop="amount">-->
<!--                                <el-input v-model="ruleForm.amount" placeholder="请输入涉案金额" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input>-->
<!--                            </el-form-item>-->
                        </el-form>
                </el-tabs>
            </div>
        </div>
        <!--        被申请人信息-->
        <div class="beAppliedBox">
            <div class="beAppliedTitle">
                <p>被申请人信息</p>
                <div style="display: flex">
                    <p  class="increaseBox"  @click="increase">添加</p>
                </div>
            </div>
            <div class="beAppliedContent" v-for="(item,index) in information" :key="index">
                <el-form :model="item" :rules="rules" ref="information" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model="item.name" placeholder="请输入姓名或公司名称"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="mobile">
                        <el-input v-model="item.mobile" placeholder="请输入手机号" oninput ="value=value.replace(/[^0-9.]/g,'')" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="证件号" prop="idcardnum">
                        <el-input v-model="item.idcardnum" placeholder="请输入身份证号或企业统一社会信用代码"></el-input>
                    </el-form-item>
                    <el-form-item label="性别" prop="gender">
                        <el-radio v-model="item.gender" label="1">男</el-radio>
                        <el-radio v-model="item.gender" label="2">女</el-radio>
                    </el-form-item>
                    <el-form-item label="民族" prop="nation">
                        <el-input v-model="item.nation" placeholder="请输入民族"></el-input>
                    </el-form-item>
                    <el-form-item label="电子邮箱" prop="email">
                        <el-input v-model="item.email" placeholder="请输入电子邮箱" ></el-input>
                    </el-form-item>
                    <el-form-item label="住址" prop="address">
                        <el-input v-model="item.address" placeholder="请输入住址" ></el-input>
                    </el-form-item>
                </el-form>
                <div class="deleteBox" @click="expurgate(index)" v-if="information.length>1">
                    删除
                </div>
            </div>
        </div>
        <!--        保存-->
        <div class="saveBox" @click="save">
            保存
        </div>
    </div>
</template>

<script>
    import { putOnRecord } from '../../../api/mediateCase';

    export default {
        name: 'mediationFiling',
        inject: ['reload'],
        data(){
            return{
                textarea:'', //填写仲裁请求
                reason:'',  //事实与理由
                ruleForm:{
                    need_tjshu:'1', //是否出调解书
                    clause:'', //合同名称
                    contract_sn:'', //合同编号
                    time:'',   //时间
                },
                signers:[], //被申请人
                agreement:{
                    date:'',
                    brief:'',
                    money:'',
                },
                information:[{
                    name:'',  //姓名
                    nation:'', //民族
                    gender:'1',  //性别
                    mobile:'',//手机号
                    idcardnum:'', //身份证号
                    email:'', //电子邮箱
                    address:'', //住址
                }],
                rules: {
                    need_tjshu:[
                        { required: true },
                    ],
                    clause: [
                        { required: true, message: '请输入合同名称', trigger: 'blur' },
                    ],
                    //签订日期
                    time:[
                        {required: true,message: '请选择日期'}
                    ],
                    //案由
                    // cause:[
                    //     {required: true,message: '请输入案由'}
                    // ],
                    //涉案金额
                    // amount:[
                    //     {required: true,message: '请输入涉案金额'}
                    // ],
                    //签订日期
                    date:[
                        {required: true,message: '请选择日期'}
                    ],
                    //案由
                    brief:[
                        {required: true,message: '请输入案由'}
                    ],
                    money:[
                        {required: true,message: '请输入涉案金额'}
                    ],
                    name:[
                        {required: true,message: '请输入姓名'}
                    ],
                    mobile:[
                        {required: true,message: '请输入手机号'}
                    ],
                    idcardnum:[
                        {required: true,message: '请输入身份证号'}
                    ]
                }
            }
        },
        methods:{
            //添加
            increase(){
                this.information.push(
                    {
                        name:'',  //姓名
                        nation:'', //民族
                        gender:'1',  //性别
                        mobile:'',//手机号
                        idcardnum:'', //身份证号
                        email:'', //电子邮箱
                        address:'', //住址
                    }
                )
            },
            //删除
            expurgate(index){
                this.information.splice(index,1)
            },
            //保存
            save(){
                putOnRecord(this.ruleForm.need_tjshu,this.ruleForm.clause,this.ruleForm.contract_sn,this.ruleForm.time,this.information).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.$router.push('/mediate')
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            getTime(){
            }
        },
    };
</script>

<style scoped>
    .newsBox{
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }
    .signBox{
        border: 1px solid #dfdfdf;
    }
    .signTitle,
    .requestTitle,
    .reasonTitle{
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #dfdfdf;
    }
    .beAppliedTitle{
        display: flex;
        height: 50px;
        line-height: 50px;
        border: 1px solid #dfdfdf;
        border-bottom: none;
        justify-content: space-between;
        align-items: center;
    }
    .beAppliedTitle>div{
        margin-right: 20px;
        font-size: 14px;
        cursor: pointer;
    }
    .signTitle>p,
    .beAppliedTitle>p,
    .requestTitle>p,
    .reasonTitle>p{
        margin-left: 20px;
        font-size: 14px;
    }
    .signContent>p{
        height: 50px;
        line-height: 50px;
        margin-left: 20px;
        font-size: 14px;
    }
    /deep/.el-tabs__nav-wrap::after{
        background-color: transparent;
    }
    /deep/.el-tabs{
        margin: 5px 50px 20px 50px;
    }
    /deep/.el-input--small{
        width: 30%;
    }
    /deep/.el-tabs__active-bar{
        background-color: transparent;
    }
    .requestBox,
    .reasonBox{
        border: 1px solid #dfdfdf;
        margin-top: 20px;
    }
    .beAppliedBox{
        margin-top: 20px;
    }
    .beAppliedContent{
        border:1px solid #dfdfdf;
        padding: 20px;
        overflow: hidden;
    }

    .requestContent,
    .reasonContent{
        padding: 20px;
    }
    /deep/.el-textarea{
        width: 100% !important;
    }
    .saveBox{
        width: 80px;
        height: 35px;
        background-color: #3e62f6;
        color: #fff;
        margin: 30px auto;
        text-align: center;
        line-height: 35px;
        border-radius: 5px;
        cursor: pointer;
    }
    .deleteBox{
        text-align: center;
        height: 30px;
        background-color: #3e62f6;
        color: #fff;
        width: 80px;
        float: right;
        line-height: 30px;
        cursor: pointer;
        border-radius: 5px;
    }
    .increaseBox{
        width: 80px;
        height: 30px;
        background-color: #3e62f6;
        color: #fff;
        border-radius: 5px;
        text-align: center;
        line-height: 30px;

    }
</style>
